import { t } from "i18next"
import { languageTranslationKeys, SpeechLanguageShortcut } from "@callcenter/shared-types"

export const buildTranslateFromOptions = (
  languages: Array<{ key: SpeechLanguageShortcut; enabled: boolean }>,
  translate_to: SpeechLanguageShortcut | null
) =>
  languages
    .map(({ key }) => ({
      value: key,
      label: t(languageTranslationKeys[key]),
      disabled: key === translate_to
    }))
    .sort((a, b) => a.label.localeCompare(b.label))

export const buildTranslateToOptions = (translate_from: Array<SpeechLanguageShortcut>) =>
  Object.values(SpeechLanguageShortcut)
    .map((key) => ({
      value: key,
      label: t(languageTranslationKeys[key]),
      disabled: translate_from.includes(key)
    }))
    .sort((a, b) => a.label.localeCompare(b.label))
